import React from 'react';
export interface CalendarVisualData {
  year: number;
  month: number;
  highlightDates?: number[];
  todayDate?: number;
  targetDate?: number;
  secondMonth?: number;
  secondMonthYear?: number;
  secondMonthHighlight?: number[];
  secondMonthTarget?: number;
  label?: string;
}
const MONTH_NAMES = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
const DAY_HEADERS = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];
const getDaysInMonth = (year: number, month: number) => {
  const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const daysPerMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return daysPerMonth[month - 1];
};
const getStartDay = (year: number, month: number) => {
  const day = new Date(year, month - 1, 1).getDay();
  return day === 0 ? 6 : day - 1; // Convert Sunday=0 to Monday=0
};
const MonthGrid: React.FC<{
  year: number;
  month: number;
  highlightDates?: number[];
  todayDate?: number;
  targetDate?: number;
}> = ({
  year,
  month,
  highlightDates = [],
  todayDate,
  targetDate
}) => {
  const daysInMonth = getDaysInMonth(year, month);
  const startDay = getStartDay(year, month);
  const monthName = MONTH_NAMES[month - 1];
  const days = Array.from({
    length: daysInMonth
  }, (_, i) => i + 1);
  const emptyCells = Array.from({
    length: startDay
  }, (_, i) => i);
  return <div className="bg-white rounded-xl shadow-sm border border-orange-100 overflow-hidden w-full max-w-sm mx-auto" data-id="element-7768">
      <div className="bg-orange-500 text-white text-center py-3 font-bold text-lg capitalize" data-id="element-7769">
        {monthName} {year}
      </div>
      <div className="p-4" data-id="element-7770">
        <div className="grid grid-cols-7 gap-1 mb-2" data-id="element-7771">
          {DAY_HEADERS.map((day, index) => <div key={day} className={`text-center text-xs font-bold uppercase ${index >= 5 ? 'text-orange-300' : 'text-orange-600'}`} data-id="element-7772">
              {day}
            </div>)}
        </div>
        <div className="grid grid-cols-7 gap-1" data-id="element-7773">
          {emptyCells.map(cell => <div key={`empty-${cell}`} className="h-8 w-8" data-id="element-7774" />)}
          {days.map(day => {
          const isToday = day === todayDate;
          const isTarget = day === targetDate;
          const isHighlighted = highlightDates.includes(day);
          const dayOfWeek = (startDay + day - 1) % 7;
          const isWeekend = dayOfWeek >= 5;
          let baseClasses = 'h-8 w-8 flex items-center justify-center rounded-full text-sm font-medium transition-colors';
          let stateClasses = '';
          if (isTarget) {
            stateClasses = 'bg-orange-500 text-white shadow-md ring-2 ring-orange-200 ring-offset-1';
          } else if (isToday) {
            stateClasses = 'border-2 border-amber-500 text-amber-700 font-bold bg-amber-50';
          } else if (isHighlighted) {
            stateClasses = 'bg-orange-100 text-orange-800';
          } else {
            stateClasses = isWeekend ? 'text-slate-400' : 'text-slate-700';
          }
          return <div key={day} className="flex items-center justify-center" data-id="element-7775">
                <div className={`${baseClasses} ${stateClasses}`} data-id="element-7776">{day}</div>
              </div>;
        })}
        </div>
      </div>
    </div>;
};
export function CalendarVisual({
  year,
  month,
  highlightDates,
  todayDate,
  targetDate,
  secondMonth,
  secondMonthYear,
  secondMonthHighlight,
  secondMonthTarget,
  label
}: CalendarVisualData) {
  return <div className="flex flex-col items-center gap-6 w-full py-4" data-id="element-7777">
      {label && <h3 className="text-lg font-semibold text-slate-800 text-center" data-id="element-7778">
          {label}
        </h3>}
      <div className="flex flex-col md:flex-row gap-6 justify-center items-start w-full" data-id="element-7779">
        <MonthGrid year={year} month={month} highlightDates={highlightDates} todayDate={todayDate} targetDate={targetDate} data-id="element-7780" />
        {secondMonth && <MonthGrid year={secondMonthYear || year} month={secondMonth} highlightDates={secondMonthHighlight} targetDate={secondMonthTarget} data-id="element-7781" />}
      </div>
    </div>;
}